<template>
<div>
    <!--  <vs-sidebar
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isSidebarActiveLocal"
      style="overflow-y: scroll"
    > -->
    <!-- {{get_leads_sidebar_data}} -->
      
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>VIEW DETAILS</h4>

        <!-- <vs-button color="primary" type="border" style="padding: 6px; border-radius: 10px; margin-left: -88px;"
        :to="{name: 'lead-edit',
             params: { 'leadId':1}}"
        >Edit</vs-button> -->
        <feather-icon
          icon="XIcon"
          class="cursor-pointer"
          @click.stop="isSidebarActiveLocal = false"
        />
      </div>
      <vs-divider class="mb-0" />
      <div class="activity_timeline_holder">
        <table
          v-if="get_leads_sidebar_data"
          class="pl-5 mt-5 leads_sidebar_table"
          style="width: 100%"
        >
          <tr>
            <td >Name:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.lead_first_name }} {{ get_leads_sidebar_data.lead_last_name }}
              </span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.email">
            <td>Email:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.email }}
              </span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.phone">
            <td> Phone:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.phone }}
              </span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.tags">
            <td v-if="get_leads_sidebar_data.tags.length>0">Tags:</td>
            <td v-if="get_leads_sidebar_data.tags.length>0"><span v-for="(item1,index) in get_leads_sidebar_data.tags" :key="index" style="font-weight: 700">{{ item1.tag.name }}, </span></td>
          </tr>
          <tr>
            <td>Status:</td>
            <td>
              <!-- {{get_leads_sidebar_data}} -->
              <span style="font-weight: 700">
              
{{getstatusName()}}
              </span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.country_details">
            <td>Country:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.country_details.country_name }}
              </span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.lead_state">
            <td >State:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.lead_state }}
              </span>
            </td>
          </tr>
          <tr  v-if="get_leads_sidebar_data.lead_address1">
            <td>Address:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.lead_address1 }}
              </span>
            </td>
          </tr>
          <tr  v-if="get_leads_sidebar_data.lead_zip">
            <td>Zip:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.lead_zip }}
              </span>
            </td>
          </tr>
          <tr v-if="get_leads_sidebar_data.lead_city">
            <td>City:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.lead_city }}
              </span>
            </td>
          </tr>
          <tr>
            <td>Created At:</td>
            <td>
              <span style="font-weight: 700">
                {{ get_leads_sidebar_data.created_at | dateFormatLocalization }}
              </span>
            </td>
          </tr>
        </table>

        <activity-timeline :no_shadow="true" :lead_id="get_leads_sidebar_data.leads_id" />
      </div>

    </div>
</template>
<script>
import activityTimeline from './ActivityTimeline.vue'

export default {
  components:{
    activityTimeline
  },
  data () {
    return {
      status_name: ''
    }
  },
  computed:{
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        
        if (!val) {
          
          this.$emit('closeSidebar')
        }
      }
    }
  },
  props:{
    isSidebarActive:{},
    get_leads_sidebar_data:{
      /*  type:Object,
      required:true,
      default:() => {} */
    }
    /*  timelineData:{
      type:Array,
      required:true,
      default:() => []
    } */
  },
  methods:{
    handleViewSidebar () {
      this.isSidebarActive = false
    //   this.$emit('closeSidebar')
    },
    getstatusName () {
      this.get_leads_sidebar_data.status_list.forEach(element => {
        if (element.leads_status_id === this.get_leads_sidebar_data.leads_current_status_id) {
          this.status_name = element.status_name
        }
      })
      return this.status_name
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

body {
  margin: 0;
}

.example-list-item {
  margin: 0;
  padding: 0 10px;
  font-size: 14px;
  line-height: 40px;
  color: #666;
  background-color: #fafafa;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #e3e3e3;
}

.example-list-item::before {
  content: "Line: ";
}

.con-vs-dialog .vs-dialog {
  z-index: 3000000000000000000000;
}
li {
  list-style: none;
}
</style>
<style>
.leads_sidebar_table td{
  padding: 10px 0;
}
.activity_timeline_holder {
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>